import { getAssetPath } from "@stencil/core";
import {
  NavigationMode,
  NavigationModeType,
  NavigationTheme,
  NavigationThemeType,
} from "./constants";
import { Application, ApplicationType } from "./constants/app";
import { getConfig } from "./helper";
import { Environment } from "../entities/environment";

export function sanitizeTheme(theme: NavigationThemeType): NavigationThemeType {
  if (!Object.keys(NavigationTheme).includes(theme)) {
    return NavigationTheme.light;
  }
  return theme;
}

export function sanitizeMode(mode: NavigationModeType): NavigationModeType {
  if (!Object.keys(NavigationMode).includes(mode)) {
    return NavigationMode.navbar;
  }
  return mode;
}

export function sanitizeApp(app: string): ApplicationType {
  if (!Object.keys(Application).includes(app)) {
    return Application.default;
  }
  return app as ApplicationType;
}

export function getSeriesImage(image: string, env: Environment): string {
  const assetPath = getAssetPath(`${getConfig(env).ASSETS_URL}/series-assets`);

  return `${assetPath}/all/${image}.webp, ${assetPath}/all/${image}@2x.webp 2x`;
}
